import { render, staticRenderFns } from "./onlineOther.vue?vue&type=template&id=21b9d138&scoped=true"
import script from "./onlineOther.vue?vue&type=script&lang=js"
export * from "./onlineOther.vue?vue&type=script&lang=js"
import style0 from "./onlineOther.vue?vue&type=style&index=0&id=21b9d138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9d138",
  null
  
)

export default component.exports